import type { ReactNode } from "react";

/** Строка с чекбоксом (юнит гайда, задача практики). На мобильном ≥ 44px. */
export function CheckRow({
  checked,
  onChange,
  label,
  meta,
  disabled,
  id,
}: {
  checked: boolean;
  onChange: (on: boolean) => void;
  label: ReactNode;
  meta?: ReactNode;
  disabled?: boolean;
  id?: string;
}) {
  return (
    <label className={`flex min-h-[44px] cursor-pointer items-start gap-3 py-2 md:min-h-0 md:py-1.5 ${disabled ? "cursor-not-allowed opacity-60" : ""}`}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 size-4 flex-none accent-[var(--acc)]"
      />
      <span className={`text-[13px] leading-[1.5] ${checked ? "text-mut" : "text-ink"}`}>{label}</span>
      {meta && <span className="ml-auto font-mono text-[11px] text-mut">{meta}</span>}
    </label>
  );
}
